import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    busqueda: {
        tipo_busqueda: "avanzada",
        marca_id: '',
        modelo_id: '',
        linea_id: '',
        version_id: '',
        val_marca: null,
        val_linea: null,
        titulo_vehiculo: '',
        tags_vehiculos: [],
        tags_marcas: [],
        rango_precio: [],
        rango_ano: [],
        resultado: [],
        search: false,
        match: []
    },
    cliente: {
        nombre: "",
        apellido: "",
        celular: "",
        whatsapp: "",
        whatsapp_checked: "",
        ubicacion_id: "",
        ubicacion_name: "",
        email: "",
        clientes: []
    },
    reportes: [],
    consultas: [],
    step: 'cliente',
    errors: {
        "cliente.nombre": '',
        "cliente.apellido": '',
        "cliente.email": '',
        "cliente.celular": ''
    }
};
const mutations = {
    updateField,
    updateReportes: (state, payload) => {
        state.reportes = payload;
    },
    updateReportesPerConsulta: (state, payload) => {
        state.consultas = payload;
    },
    updateReporte: (state, payload) => {
        console.log(payload);
        // state.busqueda = payload;
    },
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
